import  Vue from 'vue'
// 日期
Vue.filter('filterDate', function (value) {
  if (value) {
    if (!value) return '--';
    return value.slice(0, 10);
  } else {
    return '--'
  }
})




// WEBPACK FOOTER //
// ./src/api/filter.js